// 9fbef606107a605d69c0edbcd8029e5d

export const getDepartments = (state) => state.DynamicSizeChart.departments;

export const getCategories = (state) => state.DynamicSizeChart.categoryData;
